import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { MasterDetails } from 'src/app/Models/masterdetail';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-masterdetail',
  templateUrl: './masterdetail.component.html',
  styleUrls: ['./masterdetail.component.css']
})
export class MasterdetailComponent implements OnInit {

  @Input() drawerClose: Function;
  @Input() data: MasterDetails;
    isSpinning = false
  logtext:string = "";



  constructor(private api: ApiService, private message: NzNotificationService) {
  }

  ngOnInit() {
  
  }
  


  close(): void {
    this.drawerClose();

	this.logtext = 'CLOSED - MasterDetails form';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

  }

  save(addNew: boolean): void {
    var isOk = true
    if (this.data.ADDRESS == undefined || this.data.ADDRESS=="") {
      this.message.error("Please Enter Address" , "");
      isOk = false
    }
    var isOk = true
    if (this.data.PHONE_NO == undefined || this.data.PHONE_NO=="") {
      this.message.error("Please Enter Phone no" , "");
      isOk = false
    }
    var isOk = true
    if (this.data.FB_LINK == undefined || this.data.FB_LINK=="") {
      this.message.error("Please Enter FB Link" , "");
      isOk = false
    }
    var isOk = true
    if (this.data.LINKED_LINK == undefined || this.data.LINKED_LINK=="") {
      this.message.error("Please Enter Linked Link" , "");
      isOk = false
    }
    var isOk = true
    if (this.data.SKYPE_LINK == undefined || this.data.SKYPE_LINK=="") {
      this.message.error("Please Enter Skype Link" , "");
      isOk = false
    }
    var isOk = true
    if (this.data.INSTA_LINK == undefined || this.data.INSTA_LINK=="") {
      this.message.error("Please Enter Insta Link" , "");
      isOk = false
    }
    var isOk = true
    if (this.data.COLOR1 == undefined || this.data.COLOR1=="") {
      this.message.error("Please Enter Color1" , "");
      isOk = false
    }

    var isOk = true
    if (this.data.COLOR2 == undefined || this.data.COLOR2=="") {
      this.message.error("Please Enter Color2" , "");
      isOk = false
    }
    var isOk = true
    if (this.data.COLOR3 == undefined || this.data.COLOR3=="") {
      this.message.error("Please Enter Color3" , "");
      isOk = false
    }
    var isOk = true
    if (this.data.COLOR4 == undefined || this.data.COLOR4=="") {
      this.message.error("Please Enter Color4" , "");
      isOk = false
    }
    var isOk = true
    if (this.data.COLOR5 == undefined || this.data.COLOR5=="") {
      this.message.error("Please Enter Color5" , "");
      isOk = false
    }
    var isOk = true
    if (this.data.COLOR6 == undefined || this.data.COLOR6=="") {
      this.message.error("Please Enter Color6" , "");
      isOk = false
    }
    const expression = /^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/;
    if (!expression.test(String(this.data.EMAIL_ID).toLowerCase())) {
      this.message.error("Please Enter  Email-Id","")
      isOk = false;
    }


if(isOk)
{


    this.isSpinning = true;
  
      if (this.data.ID) {

	

        this.api.updateMasterDetails(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("MasterDetails information updated Successfully...", "");

	this.logtext = 'Update & Close - MasterDetails form - SUCCESS '+ JSON.stringify(this.data)+" KEYWORD [U - MasterDetails ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              if (!addNew)
                this.drawerClose();
              this.isSpinning = false;
            }
            else {

	this.logtext = 'Update & Close - MasterDetails form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [U - MasterDetails ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              this.message.error("Failed to update masterDetails information...", "");
              this.isSpinning = false;
            }
          });
      }
      else {

        this.api.createMasterDetails(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("MasterDetails information added successfully...", "");

              if (!addNew)
	{
                this.drawerClose();

	this.logtext = 'Save & Close - MasterDetails form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - MasterDetails ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
	}

              else {
                this.data = new MasterDetails();
	this.logtext = 'Save & New - MasterDetails form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - MasterDetails ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              }
              this.isSpinning = false;
            }
            else {
              this.message.error("Failed to add masterDetails information...", "");
	this.isSpinning = false;
	this.logtext = 'Save & Close - MasterDetails form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [C - MasterDetails ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
              
            }
          });
      }
  }
}


}